
import { useEffect } from 'react'
import Select from 'react-select'
import { FinancialYearDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const FinancialYearDataDDL = (props) => {
    const { FinancialYear, setFinancialYear, Flag, HYear, YLable, isCompulsory } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token }
        dispatch(FinancialYearDDLAPI({ data }))
    }, [])

    const { FinancialYearData } = useSelector(state => state.FinancialYearDDLData)

    useEffect(() => {
        handleFinancialYearDDL()
    }, [FinancialYearData])

    const handleFinancialYearDDL = () => {
        // console.log(DeptDDLDataa)
        if (FinancialYearData && FinancialYearData.table && FinancialYearData.table.length > 0) {
            let list = FinancialYearData.table.map((item, index) => ({
                value: item.id,
                label: item.financialYear,
            }))
            setFinancialYear({
                DDL: list,
                ID: Flag == 'PenealtyReport' ? list[0].value : 0,
                Label: Flag == 'PenealtyReport' ? list[0].label : "Select...",
                // ID: HYear,
                // Label: YLable,
            })
        }
        else {
            setFinancialYear({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Financial Year{isCompulsory && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                styles={{
                    option: (provided, state) => ({
                        ...provided,
                        color: 'black'
                    })
                }}
                isSearchable
                maxMenuHeight={150}
                value={{ value: FinancialYear.ID, label: FinancialYear.Label }}
                onChange={(e) => {
                    e ?
                        setFinancialYear({ ...FinancialYear, ID: e.value, Label: e.label })
                        :
                        setFinancialYear({ ...FinancialYear, ID: 0, Label: "Select..." })

                }}
                options={FinancialYear.DDL}
            />
        </div>
    )
}